<template>
  <el-dialog
    title="关联试题"
    :close-on-click-modal="false"
    :visible.sync="outerVisible"
    class="special-dialog"
    width="104.375rem"
  >
    <div class="outerVisible">
      <img src="@/assets/img/car.png" alt="" class="car" />
      <div class="car-count">{{ bucketData.length }}</div>
      <!-- <div @click="appendAll">全部试题加入</div> -->
      <div class="car-text" @click="openModel">试题篮</div>
      <el-tabs v-model="activeName" @tab-click="handleTabClick">
        <el-tab-pane label="全部" name="all"> </el-tab-pane>
        <el-tab-pane
          v-for="item in handsOnQuestionTypes"
          :key="item.value"
          :label="item.label"
          :name="String(item.value)"
        >
        </el-tab-pane>
      </el-tabs>
      <div class="content-area">
        <el-select
          v-model="courseLevelValue"
          placeholder="请选择试题难度"
          style="margin-bottom: 12px;"
          clearable
          @change="dataGet"
        >
          <el-option
            v-for="item in examLevel"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <div
          class="list"
          v-for="(item, index) in quesData"
          :key="item.questionsId"
        >
          <div class="list-style">
            <div class="header-title">
              ({{ getExamLabel(item.courseLevel) }}) {{ index + 1 }}.{{
                item.questionStem
              }}
            </div>
            <div class="bottom-option">
              <div
                style="display: flex;align-items: center;"
                v-if="item.url || item.problem"
              >
                <div style="width:80px">题目资源</div>
                <FileDetail :data="item" size="200"></FileDetail>
              </div>
              <div
                style="display: flex;align-items: center;margin-top: 8px;width: 100%;"
                v-if="item.questionAnswer"
              >
                <div style="width:80px;flex-shrink: 0;">题目答案</div>
                <div
                  style="flex:1;overflow-wrap: break-word;word-break: break-word;"
                >
                  {{ item.questionAnswer }}
                </div>
              </div>
            </div>
            <div
              class="add-bucket"
              @click="addBasket(item)"
              v-if="!bucketIds.includes(item.questionsId)"
            >
              <span>+ 加入试题篮</span>
            </div>
            <div class="remove-bucket" @click="removeBasket(item)" v-else>
              <span>- 移除试题篮</span>
            </div>
          </div>
        </div>
      </div>
      <el-pagination
        background
        layout="total, prev, pager, next"
        :total="quesTotal"
        :page-size="pageparms.pageSize"
        :current-page.sync="pageparms.pageNum"
        @current-change="currentChange"
      >
      </el-pagination>
    </div>
  </el-dialog>
</template>
<script>
import { queryInfo } from "@/api/handsOnPaper";
import FileDetail from "@/components/FileDetail.vue";
import { getList } from "@/api/handsOnBank.js";
import { handsOnQuestionTypes, getExamLabel, examLevel } from "@/utils/dict";
export default {
  data() {
    return {
      examLevel,
      handsOnQuestionTypes,
      courseLevelValue: "",
      bucketData: [],
      activeName: "all",
      outerVisible: false,
      paperData: {},
      quesData: [],
      quesTotal: 0,
      pageparms: {
        pageNum: 1,
        pageSize: 10
      }
    };
  },
  components: { FileDetail },
  computed: {
    // 判断是否在试题栏中
    bucketIds() {
      return this.bucketData.map(
        item => item.questionPracticalId || item.questionsId
      );
    }
  },
  methods: {
    getExamLabel,
    // 打开弹框
    appendAll() {
      this.bucketData = this.bucketData.concat(this.quesData);
    },
    async open(row) {
      this.paperData = row;
      this.activeName = "all";
      await this.dataGet();
      const res = await queryInfo({
        questionPracticalPaperId: row.questionPaperId
      });
      this.bucketData = res.data.data || [];
      this.outerVisible = true;
    },
    close() {
      this.outerVisible = false;
    },
    setBucket(data) {
      this.bucketData = data;
    },
    openModel() {
      if (this.bucketData.length != 0) {
        this.$emit("bucketOpen", this.paperData, this.bucketData);
      } else {
        this.$message({
          showClose: true,
          message: "请添加试题",
          type: "error"
        });
      }
    },
    // 获取试题
    async dataGet() {
      const params = { ...this.pageparms };
      params.questionType = this.activeName == "all" ? "" : this.activeName;
      params.courseLevel = this.courseLevelValue;
      const res = await getList(params);
      this.quesData = res.data.data.rows;
      this.quesTotal = res.data.data.total;
    },
    // 切换类型
    async handleTabClick(tab, event) {
      await this.currentChange(1);
    },
    // 翻页
    async currentChange(val) {
      this.pageparms.pageNum = val;
      await this.dataGet();
    },
    addBasket(item) {
      this.bucketData.push({ ...item, questionPracticalId: item.questionsId });
    },
    removeBasket(item) {
      let index = this.bucketData.findIndex(i => {
        return i.questionPracticalId == item.questionsId;
      });
      this.bucketData.splice(index, 1);
    }
  }
};
</script>
<style lang="less" scoped>
.special-dialog {
  .car {
    width: 1.5rem;
    height: 1.5rem;
    position: absolute;
    top: 2.3%;
    right: 4%;
    z-index: 9999;
  }

  .car-count {
    position: absolute;
    top: 1%;
    right: 3.5%;
    z-index: 99999;
    background: #1890ff;
    border-radius: 0.625rem;
    // padding: 0.2rem;
    width: 1.25rem;
    height: 1.25rem;
    line-height: 1.25rem;
    text-align: center;
    font-size: 0.75rem;
    font-family: PingFangSC-Regular, PingFang SC;
    color: #ffffff;
  }

  .car-text {
    font-size: 0.875rem;
    font-family: PingFangSC-Regular, PingFang SC;
    color: #8c95a6;
    position: absolute;
    top: 2.5%;
    right: 1rem;
    z-index: 99999;
    cursor: pointer;
  }

  /deep/ .el-dialog {
    margin: 0 !important;
    margin-left: 15rem !important;
    margin-top: 78px !important;
    height: calc(100vh - 90px);
  }

  /deep/ .el-dialog__body {
    padding: 1.25rem;
    padding-top: 0;
    height: calc(100vh - 184px);
    overflow-y: auto;
  }

  /deep/ .el-dialog__header {
    // padding: 0;
  }

  /deep/ .el-tabs__nav-wrap {
    background: #fafafa;
    box-shadow: 3px 4px 6px 0px rgba(240, 240, 240, 0.63);
    padding-left: 1.6875rem;
    height: 3.25rem;
    line-height: 3.25rem;
  }

  /deep/ .el-tabs__nav-wrap::after {
    background: transparent;
  }

  /deep/ .el-tabs__item {
    font-size: 0.875;
    font-family: PingFangSC-Regular, PingFang SC;
    // font-weight: 500;
    color: #8c95a6;
  }

  .outerVisible {
    height: 100%;
    position: relative;
  }

  .bucket {
    background: burlywood;
    width: 10rem;
    text-align: center;
    cursor: pointer;
  }
}
.content-area {
  // height: 43rem;
  margin-bottom: 0.5rem;

  .list {
    // display: flex;
    background-color: #fafafa;
    padding: 1.25rem 1.5rem 1.25rem 1.25rem;
    box-sizing: border-box;

    margin-bottom: 1rem;

    .list-style {
      position: relative;
      padding-bottom: 2rem;
      .header-title {
        font-size: 0.875rem;
        font-family: PingFangSC-Regular, PingFang SC;
        color: #434449;
        margin-bottom: 0.5rem;
        overflow-wrap: break-word;
        word-break: break-all;
      }
      .add-bucket {
        height: 2rem;
        background: #1890ff;
        border-radius: 0.1875rem;
        width: 6.25rem;
        line-height: 2rem;
        text-align: center;
        position: absolute;
        bottom: 0;
        right: 0;
        cursor: pointer;

        span {
          font-size: 0.875rem;
          font-family: PingFangSC-Regular, PingFang SC;
          color: #ffffff;
        }
      }

      .remove-bucket {
        height: 2rem;
        background: rgba(45, 140, 240, 0.2);
        border-radius: 0.1875rem;
        width: 6.25rem;
        line-height: 2rem;
        text-align: center;
        position: absolute;
        bottom: 0;
        right: 0;
        cursor: pointer;

        span {
          font-size: 0.875rem;
          font-family: PingFangSC-Regular, PingFang SC;
          color: #2d8cf0;
        }
      }
      .bottom-option {
        font-size: 0.875rem;
        font-family: PingFangSC-Regular, PingFang SC;
        color: #434449;
        position: relative;

        .option {
          margin-bottom: 0.5rem;
        }

        .option:last-child {
          margin-bottom: 0;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Paper/HandsOn/QuestionDialog.vue